import { useEffect } from 'react'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { useAnalytics } from '@/analytics/hooks/useAnalytics'

/**
 * Listens for global copy / paste events and pushes analytics context.
 */
export default function ClipboardAnalyticsListener() {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    const onCopy = () => trackEvent(AnalyticsEvent.ClipboardCopy)
    const onPaste = () => trackEvent(AnalyticsEvent.ClipboardPaste)

    document.addEventListener('copy', onCopy)
    document.addEventListener('paste', onPaste)
    return () => {
      document.removeEventListener('copy', onCopy)
      document.removeEventListener('paste', onPaste)
    }
  }, [trackEvent])

  return null
}
